function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23 6c-6.627 0-12 5.373-12 12v15a2 2 0 11-4 0V18C7 9.163 14.163 2 23 2h14.635a8 8 0 015.459 2.152l11.364 10.607A8 8 0 0157 20.607V46c0 8.837-7.163 16-16 16H23c-8.837 0-16-7.163-16-16v-3a2 2 0 114 0v3c0 6.627 5.373 12 12 12h18c6.627 0 12-5.373 12-12V20.607a4 4 0 00-1.27-2.924L41 7.67V13a4 4 0 004 4h2a2 2 0 110 4h-2a8 8 0 01-8-8V6H23z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.219 27.527a2 2 0 012.825.12l6.43 7a2 2 0 010 2.706l-6.43 7a2 2 0 11-2.946-2.706L36.448 38H23a2 2 0 110-4h13.448l-3.35-3.647a2 2 0 01.12-2.826z"
});

var SvgFileMove = function SvgFileMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 64 64",
    fill: "#9193A9"
  }, props), _ref, _ref2);
};

export default SvgFileMove;